import { render, staticRenderFns } from "./prescriptionDetails.vue?vue&type=template&id=fae79194&scoped=true&"
import script from "./prescriptionDetails.vue?vue&type=script&lang=js&"
export * from "./prescriptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionDetails.vue?vue&type=style&index=0&id=fae79194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae79194",
  null
  
)

export default component.exports